// Direct reads that stay when the worker API does not answer: Chainlink AggregatorV3 over JSON-RPC and
// the pool price via DexScreener.
import { MAINNET, SEL, type ChainId } from './chain';
import { callWord, callWords, RPC_TIMEOUT } from './rpc';

export interface FeedReading { price: number; updatedAt: Date }
export interface PoolReading { price: number; liquidity: number | null; volume24h: number | null }

export async function readFeed(feed: string, chainId: ChainId = MAINNET): Promise<FeedReading> {
  const [raw, dec] = await Promise.all([callWords(feed, SEL.latestRoundData, 5, chainId), callWord(feed, SEL.decimals, chainId)]);
  const b = raw.slice(2);
  const answer = BigInt('0x' + b.slice(64, 128));
  const updatedAt = Number(BigInt('0x' + b.slice(192, 256)));
  const decimals = Number(BigInt(dec));
  return { price: Number(answer) / 10 ** decimals, updatedAt: new Date(updatedAt * 1000) };
}

interface DexPair { priceUsd?: string; liquidity?: { usd?: number }; volume?: { h24?: number } }
interface DexAnswer { pairs?: DexPair[]; pair?: DexPair }

export async function readPool(pair: string): Promise<PoolReading> {
  const ctl = new AbortController();
  const timer = setTimeout(() => { ctl.abort(); }, RPC_TIMEOUT);
  try {
    const r = await fetch(`https://api.dexscreener.com/latest/dex/pairs/robinhood/${pair}`, { signal: ctl.signal });
    const j = (await r.json()) as DexAnswer;
    const p = (j.pairs ?? (j.pair ? [j.pair] : []))[0];
    if (!p) throw new Error('no pair');
    return { price: Number(p.priceUsd), liquidity: p.liquidity?.usd ?? null, volume24h: p.volume?.h24 ?? null };
  } finally {
    clearTimeout(timer);
  }
}
